import { render, staticRenderFns } from "./otherSet.vue?vue&type=template&id=579a7bc2&scoped=true"
import script from "./otherSet.vue?vue&type=script&lang=js"
export * from "./otherSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a7bc2",
  null
  
)

export default component.exports